export interface ICoachNavItem {
  titleKey: string;
  icon: string;
  url: string;
  /** Exact match for the index route, prefix match for the rest. */
  exact?: boolean;
  /** A live count shown next to the title. */
  badgeKey?: 'unreadMessages';
  /** Kept out of the sidebar; the route still works and the header still finds its title. */
  hidden?: boolean;
}

export const CoachNavItems: ICoachNavItem[] = [
  {
    titleKey: 'menu.agenda',
    icon: 'calendar',
    url: '/dashboard',
    exact: true,
  },
  {
    titleKey: 'menu.students',
    icon: 'users',
    url: '/dashboard/students',
  },
  {
    titleKey: 'menu.messages',
    icon: 'comment',
    url: '/dashboard/messages',
    badgeKey: 'unreadMessages',
  },
  {
    titleKey: 'menu.exam_mentors',
    icon: 'analysis',
    url: '/dashboard/exam-mentors',
    hidden: true,
  },
  {
    titleKey: 'menu.reports',
    icon: 'document',
    url: '/dashboard/reports',
    hidden: true,
  },
  {
    titleKey: 'menu.metrics',
    icon: 'pie-chart',
    url: '/dashboard/metrics',
  },
  {
    titleKey: 'menu.tickets',
    icon: 'chat',
    url: '/dashboard/tickets',
  },
];
